import React from 'react';
import { Grid} from '@mui/material/';
import {useStyles} from './style';

const LandingUSer=(props)=> {
    const classes = useStyles(props);

    return (
        <Grid container justifyContent={"center"} alignItems="center" flexDirection={"column"} mt={4}>
            <img className={classes.appIcon} src="menu/Logotipo.png" alt="fireSpot"/>
            <h1 className={classes.title}>Sistema Integrado de Distribución Igualitaria (SIDI) </h1>
            <div className={classes.contenedorDiv}>
                Sistema para registro de tarifarios, planes de medios y distribución igualitaria de recursos.
            </div>
        </Grid>
    )
}
export default (LandingUSer);